<template>
  <div class="full-height">
    <v-card width="100%" rounded="0" class="full-height">
      <div id="header" class="d-flex justify-start" width="100%">
        <v-icon large dark class="pa-2 ml-3 my-2 brand-background border-radius"
          >mdi-calculator-variant</v-icon
        >
        <v-card-title> {{ computedPageHeader }} </v-card-title>
      </div>
      <v-divider class="mx-4" />
      <v-row class="my-2 ml-3 mr-2">
        <v-col sm="12" md="3">
          <!-- <h2 class="align-text-left mb-3">
            Set up awards to use within your budgets and programs
          </h2>
          <v-divider></v-divider> -->
          <div class="my-4 align-text-right d-flex flex-column align-end justify-center">
            <v-autocomplete
              outlined
              dense
              class="pa-1 mb-2 full-width"
              hide-details
              :items="clients"
              item-text="formattedName"
              item-value="clientId"
              label="Client"
              v-model="clientId"
              @change="refreshClientId"
              v-if="userProfile.clientId === 1 && clients.length > 0"
            ></v-autocomplete>
            <span class="mr-3 mb-1" v-if="selected.length === 1"
              >{{ selected.length }} Award Selected</span
            >
            <span class="mr-3 mb-1" v-else>{{ selected.length }} Awards Selected</span>
          </div>
          <v-divider></v-divider>
        </v-col>
        <v-col sm="12" md="9">
          <div class="d-flex justify-space-between align-center mr-2 mb-3">
            <div class="d-flex">
              <div class="budget-button" v-if="permissions.includes('vue:read:budgets')">
                <v-btn text color="primary" class="mr-2" to="/budgets" active-class="no-active"
                  >Budgets</v-btn
                >
              </div>
              <v-btn text class="mr-2" color="primary" to="/budgets/awards" active-class="no-active"
                >Awards</v-btn
              >
              <v-btn
                v-if="permissions.includes('vue:read:badges')"
                text
                color="primary"
                to="/budgets/badges"
                active-class="no-active"
                >Badges</v-btn
              >
            </div>
            <v-text-field
              outlined
              placeholder="Search"
              prepend-icon="mdi-magnify"
              clearable
              single-line
              dense
              hide-details
              v-model="awardTableSearch"
              class="shrink"
            ></v-text-field>
            <Button
              v-if="permissions.includes('awards:create:award')"
              @click="loadAwardBuilder(null, false)"
              >Create Award</Button
            >
          </div>
          <div>
            <v-data-table
              v-model="selected"
              :headers="columns"
              :items="visibleAwards"
              item-key="awardId"
              :items-per-page="10"
              :search="awardTableSearch"
              class="elevation-0 award-table"
              :class="{
                'cursor-pointer': permissions.includes('awards:create:award'),
              }"
              :loading="loadingAwardTable"
              loading-text="Loading... Please wait"
              no-data-text="No awards found"
              no-results-text="No awards found"
              @click:row="loadEditAwardForm"
            >
              <template v-slot:[`item.displayName`]="{ item }">
                <span
                  :class="{
                    'selectable-blue-text': permissions.includes('awards:create:award'),
                  }"
                  >{{ item.displayName }}</span
                >
              </template>
            </v-data-table>
          </div>
        </v-col>
      </v-row>
    </v-card>

    <!-- Drawer used for creating and updating awards -->
    <v-navigation-drawer v-model="showAwardDialog" temporary fixed right width="500">
      <AwardCreatorWidget
        v-if="showAwardDialog"
        @close="showAwardDialog = false"
        @refreshAwards="getAwards"
        :editingAward="awardForm.editing"
        :editAwardObject="award"
        :clientId="clientId"
        source="AWARDS"
    /></v-navigation-drawer>
    <!-- Dialog used for displaying loading message. -->
    <LoadingDialog
      :showDialog="showLoadingDialog"
      :header="loadingHeaderMessage"
      :line1="loadingMessageLine1"
      :line2="loadingMessageLine2"
    ></LoadingDialog>
  </div>
</template>

<script>
import BudgetService from "../services/BudgetService.js";
import LoadingDialog from "@/components/loadingDialog.vue";
import AwardCreatorWidget from "@/components/budgets/AwardCreatorWidget.vue";
import moment from "moment";
import { mapState } from "vuex";
import Button from "@/components/generic/Button.vue";

export default {
  name: "Awards",
  title: "Awards",
  components: {
    LoadingDialog,
    AwardCreatorWidget,
    Button,
  },
  data() {
    return {
      showLoadingDialog: false,
      loadingHeaderMessage: null,
      loadingMessageLine1: null,
      loadingMessageLine2: null,
      loadingAwardTable: true,
      awardTableSearch: null,
      selected: [],
      budgets: [],
      awards: [],
      columns: [
        { text: "Name", value: "displayName", width: "40%" },
        // { text: "Value", value: "awardValue", width: "10%" },
        { text: "Description", value: "awardDescription", width: "40%" },
        { text: "Category", value: "category", width: "20%" },
        // { text: "Status", value: "status", width: "15%" }
        // { text: "Expiration Date", value: "expirationDate", width: "20%" },
      ],
      categories: ["Cash", "Travel", "Physical Award", "Other"],
      showAwardDialog: false,
      awardForm: {
        menuStartDate: false,
        menuExpirationDate: false,
        valid: false,
        editing: false,
      },
      award: {
        clientId: null,
        awardId: null,
        awardName: null,
        awardDisplayName: null,
        awardDescription: null,
        awardValue: null,
        unitSingular: null,
        unitSingularAbbreviation: null,
        unitPlural: null,
        unitPluralAbbreviation: null,
        category: null,
        cashValuePoints: false,
        expirationDate: null,
        physicalAwards: [],
        // Used to display awards in the form. Then if they save/cancel, we overwrite the normal physicalAwards array
        physicalAwardsTemp: [],
      },
    };
  },

  created() {
    if (this.$auth) {
      this.getAwards();
    }

    // this.clientId = this.userProfile.clientId;
  },
  methods: {
    getAwards() {
      BudgetService.getAwards()
        .then((response) => {
          console.log("Awards: ", response);
          //Prune the returned awards for the data we need for the table
          var awardsPruned = [];
          response.forEach(function (award) {
            if (award.status !== "Deleted") {
              if (award.expirationDate) {
                var formattedExpDate = moment(award.expirationDate, "YYYY-MM-DD hh:mm:ss").format(
                  "MMM Do YYYY"
                );
              }
              awardsPruned.push({
                clientId: award.clientId,
                displayName: award.awardDisplayName || award.awardName,
                awardDescription: award.awardDescription,
                awardValue: award.awardValue,
                status: award.status,
                category: award.category,
                expirationDate: formattedExpDate,
                awardId: award.awardId,
                name: award.awardDisplayName || award.awardName,
                id: award.awardId,
              });
            }
          });
          this.awards = awardsPruned;
          // this.$store.dispatch("setSearchArray", awardsPruned);
          this.loadingAwardTable = false;
        })
        .catch((error) => {
          console.log("Error!" + error);
          this.loadingAwardTable = false;
        });
    },
    getParentBudgets() {
      BudgetService.getParentBudgets()
        .then((response) => {
          console.log("Got parent budgets");
          response = response.filter((x) => x.status != "Deleted");
          this.budgets = response;
        })
        .catch((error) => {
          console.log("Error!" + error);
        });
    },
    resetAwardForm() {
      this.showAwardDialog = false;
      this.awardForm.showLoadingDialog = false;
      this.awardForm.editing = false;
      this.$refs.awardForm.reset();
      this.awardForm.page = 0;
    },
    loadEditAwardForm(awardId) {
      if (
        !this.permissions.includes("awards:create:award") ||
        (awardId.awardId && awardId.clientId == 0)
      ) {
        return;
      }
      console.log("Editing " + awardId);
      // Can be called when initially routing to page with just an awardId
      // Or can be called from the table, in which an entire object is passed
      if (typeof awardId == "object") {
        awardId = awardId.awardId;
      }
      this.awardForm.editing = true;
      this.showLoadingDialog = true;
      this.loadingHeaderMessage = "Loading the selected award";
      this.loadingMessageLine1 = "This should just take a minute.";
      this.loadingMessageLine2 = "";
      BudgetService.getAward(awardId)
        .then((award) => {
          console.log(award);
          var editObj = {};
          if (award.expirationDate !== null) {
            var formattedEndDate = moment(award.expirationDate, "YYYY-MM-DD hh:mm:ss").format(
              "YYYY-MM-DD"
            );
          } else {
            formattedEndDate = null;
          }
          editObj.clientId = award.clientId;
          editObj.awardId = award.awardId;
          editObj.awardName = award.awardName;
          editObj.awardDisplayName = award.awardDisplayName;

          editObj.awardDescription = award.awardDescription;
          editObj.expirationDate = formattedEndDate;
          editObj.awardValue = award.awardValue;
          editObj.unitSingular = award.unitSingular;
          editObj.unitPlural = award.unitPlural;
          editObj.category = award.category;
          editObj.cashValuePoints = award.cashValuePoints;
          editObj.unitSingularAbbreviation = award.unitSingularAbbreviation;
          editObj.unitPluralAbbreviation = award.unitPluralAbbreviation;

          editObj.physicalAwards = award.supplementAwardInfo
            ? award.supplementAwardInfo.physicalItems
              ? award.supplementAwardInfo.physicalItems
              : []
            : [];

          this.loadAwardBuilder(editObj, true);
          this.awardForm.valid = true;

          this.showLoadingDialog = false;
        })
        .catch((error) => {
          this.showLoadingDialog = false;
          this.resetAwardForm();
          console.log("Error fetching award! ", error);
        });
    },
    loadAwardBuilder(award, editing) {
      this.showAwardDialog = true;
      this.award = award;
      this.awardForm.editing = editing;
    },
    refreshClientId() {
      this.selected = [];
    },
  },
  computed: {
    ...mapState(["clients", "userProfile", "postItArray", "permissions", "globalClientId"]),
    clientId: {
      get: function () {
        return this.globalClientId;
      },
      set: function (newVal) {
        this.$store.dispatch("setClientId", newVal);
      },
    },
    visibleAwards() {
      if (this.clientId !== null) {
        return this.awards.filter((x) => x.clientId == this.clientId);
      }
      return [];
    },
    computedPageHeader() {
      var title = "";
      if (this.permissions.includes("vue:read:budgets")) {
        title = title.concat("Budgets, ");
      }
      if (this.permissions.includes("vue:read:awards")) {
        title = title.concat("Awards, ");
      }
      if (this.permissions.includes("vue:read:badges")) {
        title = title.concat("Badges, ");
      }
      if (title.endsWith(", ")) {
        title = title.substring(0, title.length - 2);
      }
      return title;
    },
  },
};
</script>

<style scoped>
.v-data-table-header {
  background-color: var(--v-lightGrey-base);
}

#template-download-button {
  margin-right: 3%;
  /* margin-bottom: 3%; */
}
.v-stepper__step__step.primary {
  background-color: red !important;
  border-color: red !important;
}
.dialog {
  z-index: inherit;
}

.budget-button .v-btn--active.no-active::before {
  opacity: 0 !important;
}

.brand-background {
  background-color: var(--v-brand-base);
}
.border-radius {
  border-radius: 5px;
}

.outlined {
  border: 1px solid;
  /* border-left: 4px; */
  border-width: 1px 1px 0px 1px;
  border-color: var(--v-grey-base);
}
.outlined-bottom {
  border-width: 1px 1px 1px 1px;
}

.award-table {
  border: solid 1px;
  border-color: lightgray;
  border-radius: 0;
}

.award-table >>> .v-data-table-header {
  background-color: white;
}
</style>
